import type { RefObject } from 'react'
import { useEffect, useRef } from 'react'

const observerOptions: IntersectionObserverInit = {
  root: null,
  rootMargin: '0px',
  threshold: 0.3
}

export const useElementViewEffect = (element: RefObject<HTMLElement>, effect: () => void) => {
  const isIntersectingRef = useRef(false)
  const callback = ([entry]: IntersectionObserverEntry[]) => {
    if (!isIntersectingRef.current && entry?.isIntersecting) {
      isIntersectingRef.current = true
      effect()
    }
  }

  useEffect(() => {
    const observer = new IntersectionObserver(callback, observerOptions)

    if (element.current) {
      observer.observe(element.current)
    }

    return () => {
      if (element.current) {
        observer.unobserve(element.current)
      }
    }
  }, [element])
}
